import { render, staticRenderFns } from "./QuartzEdit.vue?vue&type=template&id=85da7c62&scoped=true&"
import script from "./QuartzEdit.vue?vue&type=script&lang=js&"
export * from "./QuartzEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da7c62",
  null
  
)

export default component.exports